import { render, staticRenderFns } from "./billing-sidebar.vue?vue&type=template&id=93bf4c56&scoped=true&"
import script from "./billing-sidebar.ts?vue&type=script&lang=ts&"
export * from "./billing-sidebar.ts?vue&type=script&lang=ts&"
import style0 from "./billing-sidebar.scss?vue&type=style&index=0&id=93bf4c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bf4c56",
  null
  
)

export default component.exports